module.exports = __webpack_public_path__ + "img/demo-craft.30f014ce.png";